import { loadBusinesses } from "../reducers/businessReducer";
import store from "../store";
import { GET } from "./ApiRequestProvider";

export async function RefreshBusinesses() {
    const res = await GET('/api/business/list');
    if (res) {
        store.dispatch(loadBusinesses(res.data));
    }
}